<script setup>
import {ref, computed} from 'vue'
import {useViewStore} from '@/stores/view'
import {useAppStore} from '@/stores/appStore'

// Component Imports
import Button from '@/common/Button.vue'
import api from '@/services/api'

// Define Props
const props = defineProps({
    viewId: String,
})

// Stores
const viewStore = useViewStore(props.viewId)
const appStore = useAppStore()

// Reactive State
const componentIsEmpty = ref(false)

const tableName = computed(() => viewStore.tableName)
const betaMode = computed(() => appStore.betaMode)

const resetIds = async () => {
    await api.post('api/reset-components-auto-increment', {
        tableName: tableName.value,
    })
}

// Lifecycle Initialization
if (tableName.value) {
    (async () => {
        const obj = await api.get('api/component/' + tableName.value + '/id')
        componentIsEmpty.value = (
            !obj.data.values ||
            obj.data.values.length === 0
        )
    })()
}
</script>

<template>
    <div v-if="componentIsEmpty && betaMode" class="text-center">
        <div class="mt-1">
            <Button data-bs-toggle="dropdown">
                <i class="bi-three-dots"/>
            </Button>

            <div class="dropdown-menu">
                <a href @click.prevent="resetIds" class="dropdown-item">
                    Reset IDs (auto increment)
                </a>
            </div>
        </div>
    </div>
</template>